import "./LessonPlans.css";
import { useState } from "react";
import axios from "axios";
import Moment from "react-moment";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";

import PopupModal, { PopupButton } from "../Modal/Modal";

import { LessonPlanAPIs } from "../api";

import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Close, RemoveRedEye } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: "auto",
  },
  formControl: {
    minWidth: 280,
    margin: 0,
    marginBottom: "-16px",
  },
  selectBoxStyle: {
    padding: "1px 2px !important",
    border: "1px solid black !important",
    margin: "0",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
  },
  datePickerStyle: {
    backgroundColor: "transparent",
  },
  tableRow: {
    textDecoration: "none",
    fontSize: "1rem",
    whiteSpace:"nowrap",
    width:"fit-content",
    "&:hover": {
      backgroundColor: "#A6EDE5 !important",
    },
    padding:"8px",
    textAlign:"left"
  },
  tableRowExtra: {
    minWidth:"100px",
    whiteSpace:"wrap !important"
  }
}));

function Cell({ children }) {
  return (
    <TableCell
      style={{ fontWeight: "bold",fontSize: "1.1rem",padding:"8px" }}
    >
      {children}
    </TableCell>
  );
}

function LessonPlan({ item }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <TableRow variant="button" className={classes.tableRow}>
       <TableCell
        scope="row"
        align="center"
        className={`lg:text-[1.1rem] ${classes.tableRow}`}
      >
        {item.teacherId?.name || ""}
      </TableCell>
      <TableCell
        scope="row"
        align="center"
        className={`lg:text-[1.1rem] ${classes.tableRow}`}
      >
        {`${item?.sectionId?.grade || ""}-${item?.sectionId?.section}`}
      </TableCell>
      <TableCell
        align="center"
        className={`lg:text-[1.1rem] ${classes.tableRow} ${classes.tableRowExtra}`}
      >
        {item.subjectId?.name || ""}
      </TableCell>
      <TableCell
        align="center"
        className={`lg:text-[1rem] ${classes.tableRow} ${classes.tableRowExtra}`}
      >
        <p
          style={{
            wordBreak: "break-word",
            margin: "auto",
          }}
        >
          {item?.chapterId?.name || item.customChapter || ""}
        </p>
      </TableCell>
      <TableCell
        align="center"
        className={`lg:text-[1rem] ${classes.tableRow} ${classes.tableRowExtra}`}
      >
        {item?.topicId?.name || item.customTopic || ""}
      </TableCell>
      <TableCell
        align="center"
        className={`lg:text-[1rem] ${classes.tableRow} ${classes.tableRowExtra}`}
      >
        {item?.moduleId?.name || item.customModule || ""}
      </TableCell>
      <TableCell
        align="center"
        style={{ wordWrap: "nowrap" }}
        className={`lg:text-[1rem] ${classes.tableRow}`}
      >
        <Moment format="DD-MM-YYYY">{item?.startDate}</Moment>
      </TableCell>
      <TableCell
        align="center"
        style={{ wordWrap: "nowrap", textAlign:"center" }}
        className={`lg:text-[1rem] ${classes.tableRow}`}
      >
        {item?.time || "Flexible"}
      </TableCell>
      <TableCell align="center">
          <RemoveRedEye
            style={{ width: "25px", color: "#4fb8ad" }}
            onClick={() =>
              history.push(`/lessonplans/${item?._id}?action=preview`)
            }
          />
      </TableCell>
    </TableRow>
  );
}

function LessonPlans(props) {
  const classes = useStyles();
  const [popup, setPopup] = useState({});
  const [progress, setProgress] = useState(false);
  const [lessonPlan, setLessonPlan] = useState(null);

  function deleteLessonPlan() {
    if (progress) return;
    setProgress(true);
    axios
      .delete(LessonPlanAPIs.deleteLessonPlan(props.userId, lessonPlan._id), {
        headers: {
          token: localStorage.getItem("authToken"),
        },
        validateStatus: () => true,
      })
      .then((res) => {
        if (res.data.status !== "success")
          throw { message: res.data.message || "Oops Failed to delete" };

        const lps = props.lessonPlans.filter(
          (lp) => `${lp._id}` !== `${lessonPlan._id}`
        );
        props.setLessonPlans([...lps]);

        setLessonPlan(null);
        setPopup({
          open: true,
          status: "Success",
          message: "Lesson plan deleted",
        });
      })
      .catch((err) => {
        setPopup({ open: true, status: "Error", message: err.message });
      })
      .finally(() => setProgress(false));
  }

  return (
    <div>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <Cell>Teacher</Cell>
              <Cell>Grade</Cell>
              <Cell>Subject</Cell>
              <Cell>Chapter</Cell>
              <Cell>Topic</Cell>
              <Cell>Sub Topic</Cell>
              <Cell>Start Date</Cell>
              <Cell>Period</Cell>
              <Cell>Action</Cell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(props.lessonPlans || []).map((plan, index) => (
              <LessonPlan
                setLessonPlan={setLessonPlan}
                item={plan}
                key={index}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!props.loading && !props.lessonPlans?.length ? (
        <p
          style={{
            margin: "50px auto",
            textAlign: "center",
            fontSize: "1.1rem",
          }}
        >
          No Data Found
        </p>
      ) : null}
      {props.loading ? (
        <div style={{ width: "fit-content", margin: "50px auto" }}>
          <CircularProgress />
        </div>
      ) : null}
      <PopupModal
        open={lessonPlan ? true : false}
        heading="Delete"
        message="Are you sure you want to this plan?"
      >
        <PopupButton
          onClick={() => {
            if (progress) return;
            setLessonPlan(null);
          }}
        >
          {" "}
          Cancel
        </PopupButton>
        <PopupButton
          onClick={deleteLessonPlan}
          style={{
            background: "#f13a3a",
            color: "#ffffff",
          }}
        >
          {progress ? "Deleting" : "Delete"}
        </PopupButton>
      </PopupModal>
      <PopupModal
        open={popup.open}
        heading={popup.status}
        message={popup.message}
      >
        <PopupButton onClick={() => setPopup({})}>Close</PopupButton>
      </PopupModal>
    </div>
  );
}

export default LessonPlans;
